import { Card, Col, Row, Accordion } from "react-bootstrap";
import { Loader } from "../loader";
import { getRequest } from "../../utils/apiRequest";
import { useRecoilValue } from "recoil";
import { userState } from "../../utils/atom";
import { useQuery } from "@tanstack/react-query";
import "../../styles/card-list/card-list.scss";
import { formatWithDots } from "../../utils/formatNumbers";

export const UpcomingEarnings = () => {
    const { token } = useRecoilValue(userState);

    const upcomingEarnings = useQuery({
        queryKey: ["upcoming-earnings"],
        queryFn: () => getRequest("/auth/upcoming-earnings", token),
    });
    const { data } = upcomingEarnings;

    return (
        <Loader isActive={upcomingEarnings.isFetching || upcomingEarnings.isLoading}>
            {data && (
                <Card className="mt-3">
                    <Card.Header className="p-3">
                        <h5 className="m-0">Anstehende Einnahmen</h5>
                    </Card.Header>
                    <Card.Body className="p-0 border-0">
                        {Object.keys(data).length > 0 ? (
                            <Accordion defaultActiveKey={0} className="border-0">
                                {Object.values(data).map((item, index) => {
                                    return (
                                        <Accordion.Item key={index} eventKey={index}>
                                            <Accordion.Header>{item.year}</Accordion.Header>
                                            <Accordion.Body className="p-0 no-border-on-last-child overflow-hidden">
                                                {item.months.map((monthObj) => {
                                                    
                                                    const monthName = Object.keys(monthObj)[0];
                                                    const monthValue = monthObj[monthName];
                                                    
                                                    return (
                                                        <Row key={monthName} className="p-3 border-bottom">
                                                            <Col xs={6}>{monthName}</Col>
                                                            <Col xs={6} className="text-end">
                                                                {formatWithDots(monthValue)} €
                                                            </Col>
                                                        </Row>
                                                    );
                                                })}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    );
                                })}
                            </Accordion>
                        ) : (
                            <p className="m-0 p-3">Keine anstehenden Einnahmen. ☹️</p>
                        )}
                    </Card.Body>
                </Card>
            )}
        </Loader>
    );
};
